import {RouteComponents} from "./constants/RouteComponents";
import {Route, RouteComponentProps, Switch} from "react-router";
import {RouteProps, Routes} from "./constants/Routing";
import * as React from "react";
import {ApiCalls} from "./constants/ApiCalls";
import {LoggedOut} from "./screens/LoggedOut";
import {LoadingSpinner} from "./components/LoadingSpinner";

export interface SessionAppState {
    isLoggedIn: boolean;
    loggedInLoading: boolean;
    useVeriff: boolean;
    veriffLoading: boolean;
}

export interface SessionAppProps {
    handleRender: (r: RouteComponents, m: RouteComponentProps<RouteProps>) => JSX.Element;
    appId: string;
}

export class SessionApp extends React.Component<SessionAppProps, SessionAppState> {

    constructor(props: SessionAppProps) {
        super(props);
        this.state = {
            isLoggedIn: false,
            useVeriff: false,
            loggedInLoading: true,
            veriffLoading: true
        };
    }

    componentDidMount() {
        ApiCalls.getIsLoggedIn((isLoggedIn => this.setState({isLoggedIn, loggedInLoading: false})));
        ApiCalls.shouldUseVeriff(false, this.props.appId, Routes.isCOBorrower(),
                shouldUseVeriff => this.setState({useVeriff: shouldUseVeriff, veriffLoading: false}));
    }

    public render() {
        if (this.state.loggedInLoading) {
            return (<LoadingSpinner />);
        } else if (this.state.isLoggedIn) {
            if (this.state.veriffLoading) {
                return (<LoadingSpinner />);
            } else {
                return (
                    // Turning off in-house document-capture for all coborrowers
                    // https://docs.google.com/document/d/1CVUJmH3qUoQCG97k77JB317V_DPy5ybg-yJ7zmGPOwA/edit
                    <Switch>
                        <Route
                            exact={true}
                            path={[Routes.UI_PATHS.LANDING_WITH_SESSION, Routes.UI_PATHS.LANDING_WITH_SESSION_DOC]}
                            render={this.props.handleRender.bind(this,(this.state.useVeriff)?
                                RouteComponents.VERIFF: RouteComponents.UPLOAD_MANUAL_COBORROWER)}
                        />
                        <Route
                            exact={true}
                            path={[Routes.UI_PATHS.UPLOAD_WITH_SESSION,Routes.UI_PATHS.UPLOAD_WITH_SESSION_DOC]}
                            render={this.props.handleRender.bind(this, RouteComponents.UPLOAD)}
                        />
                        <Route
                            exact={true}
                            path={[Routes.UI_PATHS.UPLOAD_WITH_SESSION_DEBUG,
                                Routes.UI_PATHS.UPLOAD_WITH_SESSION_DEBUG_DOC]}
                            render={this.props.handleRender.bind(this, RouteComponents.UPLOAD_DEBUG)}
                        />
                        <Route
                            exact={true}
                            path={[Routes.UI_PATHS.UPLOAD_MANUAL_WITH_SESSION,
                                Routes.UI_PATHS.UPLOAD_MANUAL_WITH_SESSION_DOC]}
                            render={this.props.handleRender.bind(this, RouteComponents.UPLOAD_MANUAL)}
                        />
                        <Route
                            exact={true}
                            path={[Routes.UI_PATHS.ESCAPE_HATCH_WITH_SESSION,
                                Routes.UI_PATHS.ESCAPE_HATCH_WITH_SESSION_DOC]}
                            render={this.props.handleRender.bind(this, RouteComponents.ESCAPE_HATCH)}
                        />
                    </Switch>
                );
            }
        } else {
            return (<LoggedOut/>);
        }
    }
}



// WEBPACK FOOTER //
// ./src/SessionApp.tsx